/**
 * @generated SignedSource<<476afc46a50076cccf0dab1bf17bb69f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LinkSnsTypes = "Apple" | "Instagram" | "Line" | "Twitter" | "TwitterOAuth1";
export type LinkSnsMutationInput = {
  clientMutationId?: string | null;
  codeExchange: string;
  codeVerifier: string;
  redirectUri?: string | null;
  type: LinkSnsTypes;
};
export type OAuthLinkingMutation$variables = {
  input: LinkSnsMutationInput;
};
export type OAuthLinkingMutation$data = {
  readonly linkSns: {
    readonly __typename: "Influencer";
    readonly appleId: string | null;
    readonly lineId: string | null;
    readonly linkingInstagram: boolean | null;
    readonly linkingTwitter: boolean | null;
    readonly profile: {
      readonly instaFollowers: number | null;
      readonly instaId: string | null;
      readonly instaUrl: string | null;
      readonly twitterFollowers: number | null;
      readonly twitterId: string | null;
    };
  } | {
    readonly __typename: "LinkSnsError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type OAuthLinkingMutation = {
  response: OAuthLinkingMutation$data;
  variables: OAuthLinkingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkingInstagram",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkingTwitter",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appleId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterFollowers",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instaFollowers",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instaId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instaUrl",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "LinkSnsError",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OAuthLinkingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "linkSns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OAuthLinkingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "linkSns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v13/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "07a139434b5d8342a76bfab4d0371aff",
    "id": null,
    "metadata": {},
    "name": "OAuthLinkingMutation",
    "operationKind": "mutation",
    "text": "mutation OAuthLinkingMutation(\n  $input: LinkSnsMutationInput!\n) {\n  linkSns(input: $input) {\n    __typename\n    ... on Influencer {\n      linkingInstagram\n      linkingTwitter\n      lineId\n      appleId\n      profile {\n        twitterFollowers\n        twitterId\n        instaFollowers\n        instaId\n        instaUrl\n        id\n      }\n      id\n    }\n    ... on LinkSnsError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e05ed785ba94dc8738f5dde9fb1536b5";

export default node;
